var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "core/components/Icon";
export var QuotedText = function (_a) {
    var children = _a.children, variant = _a.variant, className = _a.className;
    return (React.createElement(Container, { className: className },
        React.createElement(StyledLeftIcon, { kind: "Triangle", color: "pink", direction: "right", variant: variant }),
        React.createElement(Content, null, children),
        React.createElement(StyledRightIcon, { kind: "Triangle", color: "pink", direction: "left", variant: variant })));
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 1rem;\n"], ["\n  margin: 0 1rem;\n"])));
var StyledLeftIcon = styled(Icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 0.625rem;\n  height: 0.75rem;\n\n  ", "\n"], ["\n  width: 0.625rem;\n  height: 0.75rem;\n\n  ", "\n"])), function (props) {
    return props.variant === "big" &&
        "\n    height: 1rem;\n    width: 1.125rem;\n  ";
});
var StyledRightIcon = styled(Icon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 0.625rem;\n  height: 0.75rem;\n\n  ", "\n"], ["\n  width: 0.625rem;\n  height: 0.75rem;\n\n  ", "\n"])), function (props) {
    return props.variant === "big" &&
        "\n    height: 1rem;\n    width: 1.125rem;\n  ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
